import React from 'react';
import { Link } from 'react-router-dom';
import {CheckCircle, Play, Star, MessageCircleDashed as MessageCircle, BookOpen, Globe, Award, Clock} from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-gray-800">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-blue-900 text-white lg:py-28 overflow-hidden pt-[20px] pb-[20px]">
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-6">
            <div className="space-y-6 animate-fade-in-up">
              <div className="block w-fit mx-auto bg-blue-500 bg-opacity-30 text-blue-100 rounded-full text-sm font-semibold border border-blue-400 pt-[4px] pl-[16px] pr-[16px] pb-[4px]">Oferta Exclusiva: Teste Grátis por 7 Dias

              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-center">
                Aprenda inglês de forma <span className="text-blue-300">fácil, prática e acessível.</span>
              </h1>
              <p className="text-lg md:text-xl text-blue-100 text-center">
                Aproveite seu acesso ilimitado ao EW Pass por 7 dias sem pagar nada!
              </p>
            </div>

          </div>

          <div className="text-center">
            


            
            {/* Step by Step Section */}
            <div className="mt-[15px] mb-[15px]">
              <h3 className="text-xl font-semibold text-white mb-4">Como garantir seu teste grátis?</h3>
              <div className="flex flex-wrap justify-center gap-4 text-blue-100 text-sm">
                <div className="flex items-center gap-2">
                  <span className="bg-orange-500 w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs">1</span>
                  <span>Clique no botão</span>
                </div>
                <span className="text-blue-300">→</span>
                <div className="flex items-center gap-2">
                  <span className="bg-orange-500 w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs">2</span>
                  <span>Cadastre-se</span>
                </div>
                <span className="text-blue-300">→</span>
                <div className="flex items-center gap-2">
                  <span className="bg-orange-500 w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs">3</span>
                  <span>Receba acesso no seu email</span>
                </div>
                <span className="text-blue-300">→</span>
                <div className="flex items-center gap-2">
                  <span className="bg-orange-500 w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs">4</span>
                  <span>Aproveite seu teste grátis</span>
                </div>
              </div>
            </div>

            <Link
              to="https://acesso.ewpass.com.br/convite/teste-gratis-o-ew-pass-pro-por-7-dias/01kbdptyxe7mwtczb98x61aq7w"
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-12 rounded-full text-xl shadow-lg transition-all transform hover:scale-105 hover:shadow-xl inline-block">
              QUERO TESTAR GRÁTIS
            </Link>
            <p className="mt-4 text-sm text-blue-300">Sem compromisso. Cancele quando quiser.</p>
            <div className="mt-4">
              <Link to="/v2" className="text-blue-200 underline hover:text-white transition-colors">
                Ver página English Work →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>);

}